export enum ProjectStatus {	
	New = 0,
	Open = 10,
	Complete = 20,
	Inactive = 40,
}